import { ITheme } from "@xterm/xterm";

export const darkTheme: ITheme = {
  background: "#0c0c0c",
  foreground: "#e5e7eb",
  cursor: "#60a5fa",
  cursorAccent: "#1e40af",
  selectionBackground: "#374151",
  black: "#1f2937",
  red: "#ef4444",
  green: "#10b981",
  yellow: "#f59e0b",
  blue: "#3b82f6",
  magenta: "#8b5cf6",
  cyan: "#06b6d4",
  white: "#e5e7eb",
  brightBlack: "#6b7280",
  brightRed: "#f87171",
  brightGreen: "#34d399",
  brightYellow: "#fbbf24",
  brightBlue: "#60a5fa",
  brightMagenta: "#a78bfa",
  brightCyan: "#22d3ee",
  brightWhite: "#f9fafb",
};

export const lightTheme: ITheme = {
  background: "#ffffff",
  foreground: "#1f2937",
  cursor: "#2563eb",
  cursorAccent: "#dbeafe",
  selectionBackground: "#e5e7eb",
  black: "#f3f4f6",
  red: "#dc2626",
  green: "#059669",
  yellow: "#d97706",
  blue: "#2563eb",
  magenta: "#7c3aed",
  cyan: "#0891b2",
  white: "#1f2937",
  brightBlack: "#d1d5db",
  brightRed: "#ef4444",
  brightGreen: "#10b981",
  brightYellow: "#f59e0b",
  brightBlue: "#3b82f6",
  brightMagenta: "#8b5cf6",
  brightCyan: "#06b6d4",
  brightWhite: "#111827",
};

export const getTheme = (isDarkMode: boolean): ITheme =>
  isDarkMode ? darkTheme : lightTheme;
